import { render } from "./ViewDomain.vue?vue&type=template&id=7675cc18&ts=true"
import script from "./ViewDomain.vue?vue&type=script&lang=ts"
export * from "./ViewDomain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__